import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { CostCenterModel } from '../../models';
import { CostCentersAPI } from '../../services/external/APIs';
import { AppContext } from '../context/Provider';

interface Props {
    group: number[];
    onClose: (newState: boolean) => void;
}

export const UseGetCostCentersList = ({ group, onClose }: Props) => {
    const { langResources } = useContext(AppContext);
    const [costCenterList, setCostCenterList] = useState<CostCenterModel[]>([]);

    useEffect(() => {
        CostCentersAPI.costCentersByGruop(Number(group[0]) / 10000)
            .then((res) => {
                setCostCenterList(res);
                if (res.length <= 0) {
                    toast.error(
                        langResources['assigned.cost.center.modal'][
                            'empty.list.error'
                        ],
                        {
                            isLoading: false,
                            autoClose: 5000,
                            position: toast.POSITION.BOTTOM_RIGHT,
                            closeOnClick: true,
                            closeButton: true,
                        }
                    );
                }
            })
            .catch((err) => {
                onClose(false);
                toast.error(
                    langResources['assigned.cost.center.modal']['failed.group'],
                    {
                        isLoading: false,
                        autoClose: 5000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        closeOnClick: true,
                        closeButton: true,
                    }
                );
            });
    }, [group]);

    return { costCenterList };
};
